import { Helmet } from 'react-helmet'

interface IProps {
  title: string
  description: string
  keywords: string
}

const HelmetSeo = ({ title, description, keywords }: IProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  )
}

export default HelmetSeo
